import {
  DraftConfiguration,
  DraftConfigurationSpecialTextStyle,
  DraftState,
  SpecialFontTask,
} from '@/types';
import { isDraftSpecialTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { setSpecialFontTask } from './helper/setSpecialFontTask';

export const setSpecialTextStyleAction =
  (
    { cid }: DraftConfiguration,
    style: DraftConfigurationSpecialTextStyle,
    task?: SpecialFontTask
  ) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftSpecialTextConfiguration(configuration)) {
      configuration.text.style = { ...style };
      if (task) {
        setSpecialFontTask(configuration, task);
      }
    }
  };
